import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.for-each.js";
import { defineComponent, reactive, toRefs, nextTick, ref } from 'vue';
// import { geSdkIvrList, consult, transfer, geIdelAgent } from '@app/call-center/apis/call'
import { isNumber2 } from './validate';
import { ElMessage } from 'element-plus';
// import { userModule } from '@/common/store/modules/user'
export default defineComponent({
  name: 'transferConsult',
  components: {},
  props: {
    module: {
      type: String,
      default: ''
    }
  },
  setup() {
    const cascaderRef = ref(null);
    // const USERMODULE = userModule()
    const STATE = reactive({
      activeName: 'agent',
      outlineNumber: '',
      ivrList: [],
      ivrObj: {
        name: '',
        nodeId: ''
      },
      agentOptions: [],
      form: {
        id: '',
        label: ''
      },
      props: {
        children: 'children',
        label: 'label'
      }
    });
    // 触发转接或者咨询
    const transferAction = (number, mode) => {
      if (mode === 'outline') {
        // 转外线号码，校验号码
        if (!isNumber2(number) || !number) {
          // 不是纯数字 || 没有手机号
          ElMessage.error('请输入正确的号码');
          return false;
        }
      }
      window.ueSoftphone.call.transfer({
        type: mode,
        number: number,
        success: data => {
          console.log(data, 'success============');
        },
        fail: data => {
          console.log(data, 'fail============');
        }
      });
      // let action = consult
      // const actionData: any = { number, mode }
      // if (props.module === 'transfer') {
      //   action = transfer
      // }
      // action(actionData).then((res: any) => {
      //   if (res && res.success) {
      //     if (props.module === 'consult') {
      //       // 咨询请求成功，操作按钮变更咨询ing
      //       ElMessage.success('正在为您呼叫咨询中，请等待')
      //       // 把当前咨询的座席信息存储起来，咨询转移时用得上
      //       window.sessionStorage.setItem('currentConsultAgent', label)
      //     } else {
      //       ElMessage.success(`通话已转移至${label}`)
      //     }
      //   }
      // })
      // cascaderRef.dropDownVisible = false // 收起级联组件的面板
    };
    const fetchQueueOnlineAgents = () => {
      // restFrom()
      window.ueSoftphone.agent.findIdleAgentsForQueue({
        success: res => {
          if (res && res.success && res.dataList) {
            const dataList = [];
            res.dataList.forEach(item => {
              const itemObj = {
                value: item._id,
                label: item.name,
                freeNumber: 0
              };
              let itemFreeNum = 0;
              const agentArr = [];
              if (item.members && item.members.length > 0) {
                item.members.forEach(item2 => {
                  // 排除技能组内的自己（不能自己咨询或者是转移自己）
                  if (item2.agentId !== '00000') {
                    const item2Obj = {
                      value: item2.agentId,
                      label: `${item2.agentName}[${item2.agentNumber}]`,
                      callStatus: item2.callStatus,
                      callStatusName: item2.callStatusName,
                      agentNumber: item2.agentNumber
                    };
                    if (item2.callStatus === '0') {
                      // 筛选出空闲的
                      itemFreeNum++;
                    } else {
                      item2Obj.disabled = true;
                    }
                    agentArr.push(item2Obj);
                  } else {
                    // 匹配到是自己
                    if (item.members.length === 1) {
                      // 技能组内只有一个人，还是自己，disabled
                      itemObj.disabled = true;
                    }
                  }
                });
              } else {
                itemObj.disabled = true;
              }
              itemObj.freeNumber = itemFreeNum;
              if (agentArr.length > 0) {
                itemObj.children = agentArr;
              }
              if (itemObj.freeNumber > 0) {
                dataList.push(itemObj);
              }
            });
            STATE.agentOptions = dataList;
          }
        }
      });
      // geIdelAgent({}).then((res: any) => {
      //   if (res && res.success && res.data) {
      //     const dataList: any[] = []
      //     res.data.forEach((item: any) => {
      //       const itemObj: any = { value: item._id, label: item.name, freeNumber: 0 }
      //       let itemFreeNum = 0
      //       const agentArr: any = []
      //       if (item.members && item.members.length > 0) {
      //         item.members.forEach((item2: any) => {
      //           // 排除技能组内的自己（不能自己咨询或者是转移自己）
      //           if (item2.agentId !== USERMODULE.agent._id) {
      //             const item2Obj: any = {
      //               value: item2.agentId,
      //               label: `${item2.agentName}[${item2.agentNumber}]`,
      //               callStatus: item2.callStatus,
      //               callStatusName: item2.callStatusName,
      //               agentNumber: item2.agentNumber
      //             }
      //             if (item2.callStatus === '0') {
      //               // 筛选出空闲的
      //               itemFreeNum++
      //             } else {
      //               item2Obj.disabled = true
      //             }
      //             agentArr.push(item2Obj)
      //           } else {
      //             // 匹配到是自己
      //             if (item.members.length === 1) {
      //               // 技能组内只有一个人，还是自己，disabled
      //               itemObj.disabled = true
      //             }
      //           }
      //         })
      //       } else {
      //         itemObj.disabled = true
      //       }
      //       itemObj.freeNumber = itemFreeNum
      //       if (agentArr.length > 0) {
      //         itemObj.children = agentArr
      //       }
      //       dataList.push(itemObj)
      //     })
      //     STATE.agentOptions = dataList
      //   }
      // })
    };
    const transferClick = data => {
      window.ueSoftphone.call.transfer({
        type: 'agent',
        number: data.agentNumber,
        success: data => {
          console.log(data, 'success============');
        }
      });
    };
    // 重置表单
    const restFrom = () => {
      STATE.outlineNumber = '';
      STATE.ivrObj = {
        name: '',
        nodeId: ''
      };
    };
    // tab切换
    const handleClick = () => {
      nextTick(() => {
        console.log('切换');
      });
    };
    // 获取ivr列表
    const geSdkIvrLists = () => {
      // geSdkIvrList({ hideLoading: true }).then((res: any) => {
      //   if (res.data) {
      //     STATE.ivrList = res.data || []
      //   }
      // })
    };
    const visibleChange = visible => {
      if (visible) {
        fetchQueueOnlineAgents();
      }
    };
    // onBeforeMount(() => {
    //   console.log('nnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnn')
    //   fetchQueueOnlineAgents()
    // })
    return {
      ...toRefs(STATE),
      transferClick,
      fetchQueueOnlineAgents,
      handleClick,
      transferAction,
      visibleChange
    };
  }
});